import { Routes, Route } from 'react-router-dom';
import { useAdminAuth } from './auth/useAdminAuth';
import { MFAFlow } from './auth/MFAFlow';
import { AdminLoginScreen } from './AdminLoginScreen';
import { ControlTowerDashboard } from './ControlTowerDashboard';
import { TowerBlogSection } from './TowerBlogSection';
import { BlogList } from '../Blog/BlogList';
import { BlogEditor } from '../Blog/BlogEditor';
import { BroadcastsManager } from './BroadcastsManager';
import { PartnersPanel } from './PartnersPanel';
import { Loader2 } from 'lucide-react';


export const ControlTowerLayout = () => {
    const { session, isAdmin, assured, loading, refresh } = useAdminAuth();

    // Loading state
    if (loading) {
        return (
            <div className="h-screen w-screen bg-scrim flex items-center justify-center">
                <Loader2 className="w-8 h-8 animate-spin text-danger" />
            </div>
        );
    }

    // Authorized admin → Cockpit (with routed sections)
    if (session && isAdmin) {
        if (!assured) return <MFAFlow key={session.user.id} onSuccess={refresh} />;
        return (
            <Routes>
                <Route path="/" element={<ControlTowerDashboard />} />
                <Route path="/acquisition" element={<ControlTowerDashboard />} />
                <Route path="/retention" element={<ControlTowerDashboard />} />
                <Route path="/economics" element={<ControlTowerDashboard />} />
                <Route path="/users" element={<ControlTowerDashboard />} />
                <Route path="/usage" element={<ControlTowerDashboard />} />
                <Route path="/experiments" element={<ControlTowerDashboard />} />
                <Route path="/decisions" element={<ControlTowerDashboard />} />
                <Route path="/operations" element={<ControlTowerDashboard />} />
                <Route path="/blog" element={<TowerBlogSection><BlogList basePath="/blog" /></TowerBlogSection>} />
                <Route path="/blog/new" element={<TowerBlogSection><BlogEditor basePath="/blog" /></TowerBlogSection>} />
                <Route path="/blog/:id" element={<TowerBlogSection><BlogEditor basePath="/blog" /></TowerBlogSection>} />
                <Route path="/broadcasts" element={<BroadcastsManager />} />
                <Route path="/partners" element={<PartnersPanel />} />
                {/* Unknown tower paths fall back to the cockpit */}
                <Route path="*" element={<ControlTowerDashboard />} />
            </Routes>
        );
    }

    // Not logged in OR logged in but not admin
    return <AdminLoginScreen isUnauthorized={session !== null && !isAdmin} />;
};
